import React from 'react';
import { GradientBallLeft, GradientBallRight } from '../../constants/ImagePaths';
import Image from '../../components/general/Image';
import { HireIcon1 } from "../../constants/ImagePaths"
import Button from '../../components/general/Button';
import { ROUTES } from '../../routes/RouteList';
import { ArrowUpRight } from '../../components/common/Icons';

const HireConfidence = () => {
  return (
    <div className='relative'>
      <section className="!py-[30px] md:!py-[50px] --layout-padding max-width lg:!pb-0">
        <Image src={GradientBallLeft} className="absolute top-[80px] right-0 h-[500px] hidden lg:block" alt="" />
        <Image src={GradientBallRight} className="absolute bottom-0 left-0 h-[500px] hidden lg:block" alt="" />

        <div className=" text-black">
          <div className="">
            <h2 className="text-[30px] lg:text-55 font-semibold text-center">Your next hire is already waiting</h2>
            <ul className="flex flex-col gap-[20px] mt-[20px] lg:mt-[50px] lg:flex-row lg:gap-0 lg:justify-center">
              <li style={{ backgroundImage : 'linear-gradient(104deg, #eaf2fb 0%, #fcebe4 100%)' }} className='py-[30px] px-[20px] rounded lg:translate-x-[50px] lg:w-[400px]'>
              <Image src={HireIcon1} alt="" className="mb-[10px]"/>
                <div className="text-[20px]">
                  Explore Instantly
                </div>
                <p className='text-primary-color font-extralight'>Check out dev profiles now.</p>
                <p className='text-[16px] mt-[30px]'>Complete a short intake form and <br className='hidden lg:block' /> review hand-picked profiles. </p>
              </li>
              <li style={{ backgroundImage : 'linear-gradient(104deg, #eaf2fb 0%, #fcebe4 100%)', position: 'relative', zIndex: 1 }} className='py-[30px] px-[20px] rounded  !lg:border !lg:border-[#FEF6F0] lg:translate-y-[100px] lg:w-[400px]'>
              <Image src={HireIcon1} alt="" className="mb-[10px]"/>
                <div className="text-[20px]">
                  Interview
                </div>
                <p className='text-primary-color font-extralight'>1-3 days</p>
                <p className='text-[16px] mt-[30px]'>Tell us what you need. Get 3–4 top matches in under 48 hours. Meet them and pick your fit.</p>
              </li>
              <li style={{ backgroundImage : 'linear-gradient(104deg, #eaf2fb 0%, #fcebe4 100%)' }} className='py-[30px] px-[20px] rounded lg:translate-x-[-50px] relative z-0 lg:w-[400px] lg:pl-[80px]'>
              <Image src={HireIcon1} alt="" className="mb-[10px]"/>
                <div className="text-[20px]">
                Onboard the chosen one
                </div>
                <p className='text-primary-color font-extralight'>Onboard Seamlessly</p>
                <p className='text-[16px] mt-[30px]'>In a week or less your developer joins the team. We handle contracts, payroll, and everything in between.</p>
              </li>
            </ul>
            
            <Button
              href={ROUTES.START_HIRING}
              className="mt-[20px] w-full bg-primary-color text-black rounded h-[50px] md:w-[300px] mx-auto lg:mt-[150px]"
            >
              <div className="flex items-center justify-center gap-2">
                <span>Hire with confidence</span>
                <ArrowUpRight className="w-4 h-4" />
              </div>
            </Button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HireConfidence;